import React, { useState, useContext } from "react";
import Home from "./components/Home";
import Other from "./components/Other";
import "./App.css";
import firebase from "./firebase.js";
import Footer from "./components/Footer";
import codes from "./codes.js";
import { UserProvider } from "./UserContext";

function App() {
  // Hooks
  const [database, setDatabase] = useState(null);
  const [user, setUser] = useState(null);
  // Firebase varriables
  const dbRef = firebase.database().ref();
  const auth = firebase.auth();
  const provider = new firebase.auth.GoogleAuthProvider();

  const setupDatabase = () => {
    dbRef.on("value", response => {
      const data = response.val();
      setDatabase(data);
    });
  };

  const writeUserData = (userId, name, email, imageUrl) => {
    firebase
      .database()
      .ref("users/" + userId)
      .set({
        codes: codes,
        email: "test",
        lyft: "code"
      });
  };

  const login = () => {
    auth.signInWithPopup(provider).then(result => {
      const user = result.user;
      setUser({
        user
      });
      writeUserData(user.uid);
    });
  };

  const logout = () => {
    auth.signOut().then(() => {
      setUser(null);
    });
  };

  const authChange = () => {
    auth.onAuthStateChanged(user => {
      setUser({
        user: user,
        name: user.displayName,
        image: user.photoURL,
        uid: user.uid
      });
    });
  };

  useState(() => {
    setupDatabase();
    authChange();
    writeUserData();
  }, [dbRef, user, auth]);

  const loading = () => {
    return (
      <div className="loadingScreen">
        <img className="preloader" src="./images/preloader.png" alt="Loading" />
      </div>
    );
  };

  return (
    <UserProvider value={user ? user : null}>
      <div className="App">
        <div className="animated fadeIn">
          {database ? (
            <Home
              codes={user ? database.users["undefined"].codes : database.mainDB}
              user={user}
            />
          ) : (
            loading()
          )}
          <div className="logIn">
            {user ? (
              <button className="loggedIn" onClick={logout}>
                Log Out
              </button>
            ) : (
              <button className="loggedOut" onClick={login}>
                Log In
              </button>
            )}
            {user ? <Other user={user.name} image={user.image} /> : null}
            <Footer />
          </div>
        </div>
      </div>
    </UserProvider>
  );
}

export default App;
